"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get DEFAULT_BATCH_LIMIT () {
        return DEFAULT_BATCH_LIMIT;
    },
    get FormulaColumnTypeChanger () {
        return FormulaColumnTypeChanger;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _utils = require("src/utils");
const _ncError = require("~/helpers/ncError");
const _dbHelpers = require("~/helpers/dbHelpers");
const _models = require("~/models");
const _columnsservice = require("~/services/columns.service");
const _mysqldatamigration = require("~/services/formula-column-type-changer/mysql-data-migration");
const _pgdatamigration = require("~/services/formula-column-type-changer/pg-data-migration");
const _sqlitedatamigration = require("~/services/formula-column-type-changer/sqlite-data-migration");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
const DEFAULT_BATCH_LIMIT = 100000;
let FormulaColumnTypeChanger = class FormulaColumnTypeChanger {
    async startChangeFormulaColumnType(context, params) {
        const baseModel = await (0, _dbHelpers.getBaseModelSqlFromModelId)({
            context,
            modelId: params.formulaColumn.fk_model_id
        });
        if (!this.dataMigrationDriver[baseModel.dbDriver.clientType()]) {
            this.logger.error(`${baseModel.dbDriver.clientType()} database is not supported in this operation`);
            _ncError.NcError.get(context).notImplemented(`${baseModel.dbDriver.clientType()} database is not supported in this operation`);
        }
        const oldTitle = params.formulaColumn.title;
        if (params.newColumnRequest.title === oldTitle) {
            // we rename the alias first so the new created temporary column
            // do not cause duplicated alias
            await _models.Column.updateAlias(context, params.formulaColumn.id, {
                title: '__nc_temp_field'
            });
        }
        let newColumn;
        try {
            newColumn = await this.columnsService.columnAdd(context, {
                tableId: baseModel.model.id,
                column: params.newColumnRequest,
                req: params.req,
                user: params.user,
                apiVersion: _nocodbsdk.NcApiVersion.V3,
                reuse: params.reuse,
                suppressFormulaError: true
            });
            try {
                await this.startMigrateData(context, {
                    formulaColumn: params.formulaColumn,
                    destinationColumn: newColumn,
                    baseModel,
                    req: params.req
                });
            } catch (ex) {
                await this.columnsService.columnDelete(context, {
                    columnId: newColumn.id,
                    req: params.req,
                    user: params.user,
                    reuse: params.reuse,
                    forceDeleteSystem: false
                });
                if (ex instanceof _ncError.NcError || ex instanceof _nocodbsdk.NcBaseError) throw ex;
                this.logger.error((ex == null ? void 0 : ex.message) || 'Failed to convert column', ex);
                _ncError.NcError.get(context).internalServerError('Failed to convert column');
            }
        } catch (ex) {
            // when failed during create new column for whatever reason
            // we need to rollback the old column name / title
            if (params.newColumnRequest.title === oldTitle) {
                await _models.Column.updateAlias(context, params.formulaColumn.id, {
                    title: oldTitle
                });
            }
            if (ex instanceof _ncError.NcError || ex instanceof _nocodbsdk.NcBaseError) throw ex;
            this.logger.error((ex == null ? void 0 : ex.message) || 'Failed to convert column', ex);
            _ncError.NcError.get(context).internalServerError('Failed to convert column');
        }
        return await _models.Column.updateFormulaColumnToNewType(context, {
            formulaColumn: params.formulaColumn,
            destinationColumn: newColumn
        });
    }
    async startMigrateData(context, { formulaColumn, destinationColumn, baseModel, req }) {
        baseModel = baseModel != null ? baseModel : await (0, _dbHelpers.getBaseModelSqlFromModelId)({
            context,
            modelId: formulaColumn.fk_model_id
        });
        const rowCount = await baseModel.count();
        if (rowCount === 0) {
            return;
        }
        const formulaColumnOption = await formulaColumn.getColOptions(context);
        for(let i = 0; i < rowCount; i += DEFAULT_BATCH_LIMIT){
            await this.migrateData({
                baseModelSqlV2: baseModel,
                destinationColumn,
                formulaColumn,
                formulaColumnOption,
                offset: i,
                limit: DEFAULT_BATCH_LIMIT,
                req
            });
        }
    }
    async migrateData({ baseModelSqlV2, formulaColumn, formulaColumnOption, destinationColumn, offset = 0, limit = DEFAULT_BATCH_LIMIT, req }) {
        const qb = baseModelSqlV2.dbDriver;
        const dataMigrationDriver = this.dataMigrationDriver[qb.clientType()];
        if (!dataMigrationDriver) {
            _ncError.NcError.get(baseModelSqlV2.context).notImplemented(`${qb.clientType()} database is not supported in this operation`);
        }
        const updatedRows = await dataMigrationDriver.migrate({
            baseModelSqlV2,
            destinationColumn,
            formulaColumn,
            formulaColumnOption,
            limit,
            offset
        });
        if ((0, _dbHelpers.isDataAuditEnabled)()) {
            const auditPayloads = [];
            for (const row of updatedRows){
                auditPayloads.push(await (0, _utils.generateUpdateAuditV1Payload)({
                    baseModelSqlV2,
                    rowId: row.primaryKeys,
                    data: row.row,
                    oldData: _extends({}, row.row, {
                        [destinationColumn.title]: null
                    }),
                    req
                }));
            }
            await _models.Audit.insert(auditPayloads);
        }
    }
    constructor(columnsService){
        this.columnsService = columnsService;
        this.logger = new _common.Logger(FormulaColumnTypeChanger.name);
        this.dataMigrationDriver = {};
        const pgDriver = new _pgdatamigration.PgDataMigration();
        const mysqlDriver = new _mysqldatamigration.MysqlDataMigration();
        const sqliteDriver = new _sqlitedatamigration.SqliteDataMigration();
        this.dataMigrationDriver['postgre'] = pgDriver;
        this.dataMigrationDriver[pgDriver.dbDriverName] = pgDriver;
        this.dataMigrationDriver['mariadb'] = mysqlDriver;
        this.dataMigrationDriver['mysql2'] = mysqlDriver;
        this.dataMigrationDriver[mysqlDriver.dbDriverName] = mysqlDriver;
        this.dataMigrationDriver[sqliteDriver.dbDriverName] = sqliteDriver;
        this.dataMigrationDriver['sqlite3'] = sqliteDriver;
    }
};
FormulaColumnTypeChanger = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_param(0, (0, _common.Inject)((0, _common.forwardRef)(()=>_columnsservice.ColumnsService))),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _columnsservice.ColumnsService === "undefined" ? Object : _columnsservice.ColumnsService
    ])
], FormulaColumnTypeChanger);
